import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=c9fca29a&scoped=true"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=c9fca29a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fca29a",
  null
  
)

export default component.exports